"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const events_1 = require("events");
// Import from the file rather than the directory in case someone consuming types is using module resolution other than "node"
const index_1 = require("./system/index");
const index_2 = require("./window/index");
const index_3 = require("./application/index");
const index_4 = require("./interappbus/index");
const index_5 = require("./clipboard/index");
const index_6 = require("./external-application/index");
const index_7 = require("./frame/index");
const index_8 = require("./global-hotkey/index");
const index_9 = require("./view/index");
const index_10 = require("./platform/index");
const me_1 = require("./me");
const interop_1 = require("./interop");
const snapshot_source_1 = require("./snapshot-source");
class Fin extends events_1.EventEmitter {
    constructor(wire) {
        super();
        this.wire = wire;
        this.System = new index_1.default(wire);
        this.Window = new index_2.default(wire);
        this.Application = new index_3.default(wire);
        this.InterApplicationBus = new index_4.default(wire);
        this.Clipboard = new index_5.default(wire);
        this.ExternalApplication = new index_6.default(wire);
        this.Frame = new index_7.default(wire);
        this.GlobalHotkey = new index_8.default(wire);
        this.Platform = new index_10.default(wire, this.InterApplicationBus.Channel);
        this.View = new index_9.default(wire);
        this.Interop = new interop_1.default(wire);
        this.SnapshotSource = new snapshot_source_1.default(wire);
        wire.registerFin(this);
        this.me = (0, me_1.getMe)(wire);
        // Handle disconnect events
        wire.on('disconnected', () => {
            this.emit('disconnected');
        });
    }
}
exports.default = Fin;
